import map from 'lodash/map';
import kebabCase from 'lodash/kebabCase';

import React from 'react';
import PropTypes from 'prop-types';
import { COLUMNS } from '../constants';

class SummaryTableBodyComponent extends React.PureComponent {
  static propTypes = {
    levelsProps: PropTypes.array.isRequired
  }

  render () {
    return (
      <tbody>
        {map(this.props.levelsProps, levelProps =>
          <tr key={levelProps.name} id={levelProps.name}>
            <td className="font-13 font-700">
              {levelProps.name}
            </td>

            <td className="font-13 font-700">
              {levelProps.numericalParameter}
            </td>

            {map(COLUMNS, (_, columnKey) =>
              <td key={columnKey} className="text-right" id={kebabCase(columnKey)}>
                {levelProps[columnKey] &&
                typeof levelProps[columnKey] === 'number'
                  ? levelProps[columnKey].toFixed(3)
                  : levelProps[columnKey]}
              </td>
            )}
          </tr>
        )}
      </tbody>
    );
  }
}

export default SummaryTableBodyComponent;
